module.exports = __webpack_public_path__ + "static/media/tiny_img_5.332904a9.png";